var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLens({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-517.000000, -749.000000) translate(400.000000, 750.000000) translate(118.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.308,
    cy: 34.308,
    r: 34.308
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.308,
    cy: 34.308,
    r: 24.264
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.167999,19.9079995 C42.9913796,21.1902347 46.1461068,23.9433334 47.9339987,27.5579993"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.e2222558dd139d7669ae443330555666.svg";
export { ForwardRef as ReactComponent };